import * as React from 'react';
import { SVGUniqueID } from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const LightbulbLineIcon: React.FC<SVGComponentProps> = ({
  width = 20,
  height = 20,
  stroke = '#EBA400',
  fill = 'none',
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.4799 14.5002H9.25015V10.7502H10.7502V14.5002H11.5204C11.6194 13.5987 12.0792 12.8547 12.8254 12.0425C12.9102 11.951 13.4494 11.3922 13.5132 11.3127C14.0429 10.6509 14.3749 9.85301 14.471 9.01081C14.5671 8.1686 14.4234 7.31638 14.0563 6.55228C13.6893 5.78818 13.114 5.14329 12.3965 4.69186C11.679 4.24043 10.8486 4.00083 10.001 4.00065C9.15329 4.00047 8.32281 4.23971 7.60515 4.69083C6.88749 5.14196 6.31184 5.78661 5.9445 6.55055C5.57716 7.31449 5.43306 8.16665 5.5288 9.0089C5.62454 9.85114 5.95622 10.6492 6.48565 11.3112C6.55015 11.3915 7.0909 11.951 7.17415 12.0417C7.92115 12.8547 8.3809 13.5987 8.4799 14.5002V14.5002ZM8.50015 16.0002V16.7502H11.5002V16.0002H8.50015ZM5.31565 12.2502C4.6093 11.3677 4.16661 10.3036 4.0386 9.18045C3.91059 8.05732 4.10245 6.92088 4.59209 5.90203C5.08173 4.88318 5.84923 4.02338 6.80617 3.42166C7.76311 2.81995 8.87057 2.5008 10.001 2.50098C11.1314 2.50116 12.2387 2.82066 13.1955 3.42269C14.1522 4.02471 14.9194 4.88476 15.4087 5.90377C15.8981 6.92277 16.0896 8.05927 15.9612 9.18236C15.8328 10.3054 15.3898 11.3694 14.6832 12.2517C14.2182 12.8307 13.0002 13.7502 13.0002 14.8752V16.7502C13.0002 17.148 12.8421 17.5296 12.5608 17.8109C12.2795 18.0922 11.898 18.2502 11.5002 18.2502H8.50015C8.10233 18.2502 7.7208 18.0922 7.43949 17.8109C7.15819 17.5296 7.00015 17.148 7.00015 16.7502V14.8752C7.00015 13.7502 5.7814 12.8307 5.31565 12.2502Z"
        fill={stroke}
      />
    </svg>
  </SVGUniqueID>
);

export { LightbulbLineIcon };
